"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pathExists_1 = __importDefault(require("../fn/pathExists"));
/**
 * has
 *
 * Checks if a path exists
 */
var has = function (db) { return function (path) {
    return (0, pathExists_1.default)(db, path);
}; };
exports.default = has;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaS9oYXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxnRUFBMEM7QUFFMUM7Ozs7R0FJRztBQUNILElBQU0sR0FBRyxHQUFHLFVBQUMsRUFBRSxJQUFLLE9BQUEsVUFBQyxJQUFJO0lBQ3ZCLE9BQU8sSUFBQSxvQkFBVSxFQUFDLEVBQUUsRUFBRSxJQUFJLENBQUMsQ0FBQztBQUM5QixDQUFDLEVBRm1CLENBRW5CLENBQUM7QUFFRixrQkFBZSxHQUFHLENBQUMifQ==